import React from 'react';
import {Box, IconButton, Modal, SxProps, Theme} from '@mui/material';
import CrossIcon from '../../../../assets/icons/CrossIcon';

export interface ModalComponentProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  width: string | number;
  padding?: number | string;
  responsivePadding?: number | string;
  modalStyleOverrides?: SxProps<Theme>;
  containerStyleOverrides?: SxProps<Theme>;
  hideCloseBtn?: boolean;
}

const ModalComponent: React.FC<ModalComponentProps> = ({
  open,
  onClose,
  children,
  width,
  padding = 3,
  responsivePadding,
  modalStyleOverrides,
  containerStyleOverrides,
  hideCloseBtn = false,
}) => {
  const style: SxProps<Theme> = {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    width,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 6,
    p: padding,
    '@media (min-width:600px)': {
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
    '@media (max-width:1000px)': {
      width: '95vw',
    },
    '@media (max-width:599px)': {
      bottom: 0,
      transform: 'translateX(-50%)',
      width: '100vw',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      p: responsivePadding,
    },
    ...containerStyleOverrides,
  };

  return (
    <Modal open={open} onClose={onClose} sx={modalStyleOverrides}>
      <Box sx={style}>
        {!hideCloseBtn && (
          <IconButton
            aria-label="close"
            size="small"
            onClick={onClose}
            sx={{position: 'absolute', top: '5px', right: '14px'}}
          >
            <CrossIcon />
          </IconButton>
        )}

        {children}
      </Box>
    </Modal>
  );
};

export default ModalComponent;
